import { useLocalStorage } from '#pplx/frontend/browser-storage/hooks/useLocalStorage.js';
export function usePartnerDiscountCode() {
    const [value, setValue] = useLocalStorage('pplx.partner_discount_code', null);
    return [value, setValue];
}
//# sourceMappingURL=usePartnerDiscountCode.js.map